module.exports = __webpack_public_path__ + "media/images/photos/NCPCpromo1-0a6032bc29905cbddb5f29dfaa49aa3d.jpg";